module.exports = __webpack_public_path__ + "img/5C.3ac88edd.png";